export default __webpack_public_path__ + "static/media/14.48356f28.jpg";